// extracted by css-extract-rspack-plugin
export default {"label":"APlsEQGDz3ABcyGm","new":"den93KFuY4dORWrh","neutral":"z2CCTqHJw8YURzrl","promo":"t3HampB7sA3gOlni"};